var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoContractManufacturingIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#00BBA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 44.9734C31.0721 45.2074 31.5319 45.3306 32 45.3306C32.4681 45.3306 32.9279 45.2074 33.3333 44.9734L42.6667 39.64C43.0717 39.4062 43.408 39.07 43.6421 38.6651C43.8761 38.2603 43.9995 37.801 44 37.3334V26.6667C43.9995 26.1991 43.8761 25.7398 43.6421 25.3349C43.408 24.9301 43.0717 24.5938 42.6667 24.36L33.3333 19.0267C32.9279 18.7927 32.4681 18.6694 32 18.6694C31.5319 18.6694 31.0721 18.7927 30.6667 19.0267L21.3333 24.36C20.9284 24.5938 20.592 24.9301 20.3579 25.3349C20.1239 25.7398 20.0005 26.1991 20 26.6667V37.3334C20.0005 37.801 20.1239 38.2603 20.3579 38.6651C20.592 39.07 20.9284 39.4062 21.3333 39.64L30.6667 44.9734Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45.3333V32",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3867 25.3333L32.0001 31.9999L43.6134 25.3333",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21.6934L38 28.56",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoContractManufacturingIcon2);
export default __webpack_public_path__ + "static/media/cdmo-contract-manufacturing-icon2.13953cbd904d35a87945b62f08211d51.svg";
export { ForwardRef as ReactComponent };